// extracted by mini-css-extract-plugin
export default {"root":"PreviewTable_root__zAu0w","paper":"PreviewTable_paper__PrxAQ","table":"PreviewTable_table__sdzZF"};